<template>
  <div>
    <h1 :class="`d-flex justify-center`">My account</h1>
    <div v-if="!loggedIn">
      <NeedLogin></NeedLogin>
      <hr />
      <ActivateAccount></ActivateAccount>
    </div>
    <div v-else>
      <v-card min-width="350" elevation="18" rounded="xl">
        <!-- <v-label>{{ items }}</v-label> -->
        <v-col cols="1"> </v-col>
        <v-col>
          <v-text-field
            :value="fullName"
            prepend-icon="mdi-account-box-outline"
            readonly
          ></v-text-field>
          <v-text-field
            :value="email"
            prepend-icon="mdi-email-outline"
            readonly
          ></v-text-field>
          <v-text-field
            :value="mobile"
            prepend-icon="mdi-cellphone"
            readonly
          ></v-text-field>
          <v-row align="center" justify="space-around">
            <v-checkbox
              :input-value="notifyEnabled"
              label="Notification activated"
              readonly
              color="grey"
            ></v-checkbox>
            <v-chip small color="primary" @click="dialog = true"
              ><v-icon small>mdi-help-circle-outline</v-icon></v-chip
            >
            <v-img :src="flagUrl" max-height="40" max-width="40"></v-img>
          </v-row>
          <v-row justify="space-around">
            <v-btn
              rounded
              v-bind:href="profileUrl"
              target="_blank"
              small
              color="primary"
            >
              Edit account settings
              <v-icon small right>mdi-account-cog-outline</v-icon>
            </v-btn>
          </v-row>
        </v-col>
        <v-col cols="1"> </v-col>
        <!-- <div>.</div> -->
      </v-card>

      <!-- <v-alert type="success" :value="isAlertVisible" dense>
      <v-btn v-bind:href="profileUrl" target="_blank" small color="primary">
        Go to account settings
        <v-icon small right>fa-user-cog</v-icon>
      </v-btn>
    </v-alert> -->
      <v-alert type="error" :value="isWarningAlertVisible" dense>{{
        statusResultMsg
      }}</v-alert>

      <v-row justify="center">
        <v-dialog
          v-model="dialog"
          fullscreen
          hide-overlay
          transition="dialog-bottom-transition"
        >
          <v-card>
            <v-toolbar dark color="primary">
              <v-btn icon dark @click="dialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-toolbar-title>Notification Service</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <NotificationServiceHelp></NotificationServiceHelp>
          </v-card>
        </v-dialog>
      </v-row>
      <!-- <v-snackbar v-model="snackbar">
      {{ snackbartext }}

      <template v-slot:action="{ attrs }">
        <v-btn color="red" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar> -->
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
// import UserApiSearch from "@/components/airbox/UserApiSearch.vue";
import NeedLogin from "@/components/Admin/NeedLogin.vue";
import NotificationServiceHelp from "@/components/help/NotificationServiceHelp.vue";
import axios from "axios";
// import ActivateAccount from "@/components/Admin/ActivateAccount.vue";
import ActivateAccount from "@/components/Admin/ActivateAccount.vue";

export default {
  name: "SendAC",
  // regid: Number,
  data() {
    return {
      regid: Number,
      ac: String,
      eyevalue: true,
      isValid: true,
      // regidRules: [(v) => !!v || "User is required"],
      // acRules: [(v) => !!v || "Access code is required"],
      // cancellink: { to: "/checkin" },
      isAlertVisible: false,
      isWarningAlertVisible: false,
      statusResult: Number,
      statusResultMsg: String,
      cancelBtnText: "",
      items: [],
      errors: [],
      // snackbar: false,
      // snackbartext: "No info.",
      cookieToken: Number,
      cookieRegId: Number,
      loggedIn: false,
      dialog: false,
      fullName: String,
      email: String,
      mobile: String,
      notifyEnabled: false,
      flagUrl: String,
    };
  },
  created() {
    this.baseUrl = "https://pgapi.azurewebsites.net/dbapi/";
    this.regid = null;
    this.isValid = false;
    this.ac = null;
    this.getCookies();
    (this.fullName = null),
      (this.email = null),
      (this.mobile = null),
      (this.notifyEnabled = false),
      (this.flagUrl = null);
  },
  methods: {
    setRegId(id) {
      this.regid = id;
      // console.log(id);
    },

    getProfileLink() {
      var regId = this.regid;
      var ac = this.ac;
      var toSubmit = JSON.stringify({ ac });
      const uri = this.baseUrl + "getprofileurlwithac/" + regId;
      // const uri = "http://localhost:3000/dbapi/" + "getprofileurlwithac/" + regId;
      // console.log("uri:", uri);
      // console.log("toSubmit", toSubmit);
      this.sendpost(uri, toSubmit, 1);
    },

    sendpost(uri, toSubmit, type) {
      const axiosConfig = {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
        },
      };
      axios
        .post(uri, toSubmit, axiosConfig)
        .then((response) => {
          this.items = response.data;
          this.fullName = this.items[0].FullName;
          this.email = this.items[0].Email;
          this.mobile = this.items[0].Mobile;
          this.notifyEnabled = this.items[0].NotifyEnabled;
          this.flagUrl = this.items[0].FlagUrl;
          if (type === 0) {
            this.statusResult = response.data.Result;
            this.statusResultMsg = response.data.ResultMsg;
          } else {
            this.statusResult = response.data[0].Result;
            this.statusResultMsg = response.data[0].ResultMsg;
          }
          if (this.statusResult == 1) {
            this.cancelBtnText = "Done";
          }
          this.setAlert(this.statusResult);
          //   if (this.statusResult === 1) {
          //       getstatus();
          //   }
        })
        .catch((e) => {
          this.errors.push(e);
          this.statusResult = 0;
          this.statusResultMsg = "Something went wrong!";
          this.setAlert(this.statusResult);
        });
    },
    getCookies() {
      this.cookieRegId = this.$cookies.get("pgbregid");
      this.cookieToken = this.$cookies.get("pgbtoken");
      this.regid = this.cookieRegId;
      this.ac = this.cookieToken;
      if (this.cookieToken > 0) {
        this.loggedIn = true;
        this.getProfileLink();
      }
    },
    setAlert(statusResult) {
      if (statusResult === 1) {
        this.isAlertVisible = true;
        this.isWarningAlertVisible = false;
      }
      if (statusResult === 0) {
        this.isWarningAlertVisible = true;
        this.isAlertVisible = false;
        // Special case link to profile page
        this.profilelink = { to: this.statusResultMsg };
      }
    },
  },
  computed: {
    profileUrl() {
      // return "http://localhost:8080/profile?pk=" + this.statusResultMsg;
      // return "https://pgbox.azureedge.net/profile?pk=" + this.statusResultMsg;
      return "/profile/" + this.statusResultMsg;
    },
  },
  components: {
    // UserApiSearch,
    NeedLogin,
    NotificationServiceHelp,
    ActivateAccount,
  },
};
</script>